// extracted by mini-css-extract-plugin
export default {"container":"ItemPartOrder_container__tr4xg","title":"ItemPartOrder_title__+1aqy","description":"ItemPartOrder_description__Tr2I7"};